import { IBancoHoras } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IBancoHorasState {
    data: IBancoHoras;
    loading: boolean;
    error: string | null;
}

const initialState: IBancoHorasState = {
    data: {} as IBancoHoras,
    loading: false,
    error: null
};

export const bancoHorasSlice = createSlice({
    name: 'bancoHoras',
    initialState,
    reducers: {
        banco_horas_fetching: (state) => {
            state.loading = true;
            state.data = {} as IBancoHoras;
            state.error = null;
        },
        banco_horas_success: (state, action: PayloadAction<IBancoHoras>) => {
            state.error = null;
            state.loading = false;
            state.data = action.payload;
        },
        banco_horas_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = {} as IBancoHoras;
        }
    }
});

export const { banco_horas_fetching, banco_horas_success, banco_horas_error } = bancoHorasSlice.actions;

export const selectorBancoHoras = (state: AppState) => state.bancoHoras;

export default bancoHorasSlice.reducer;
